import script from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=07b5eaae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b5eaae"]])

export default __exports__